import { SET_VIEW, SET_ALERT } from 'constants/actionTypes';

const initialState = {
  alert: { showing: false },
  view: { view: null, props: {} }
};

export default function(state = initialState, action) {
  switch (action.type) {
  case SET_VIEW:
    return {
      ...state,
      view: action.view
    };

  case SET_ALERT:
    return {
      ...state,
      alert: action.alert
    };

  default: return state;
  }
}